import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import Buttons from '@material-ui/core/Button';
import { Button, Grid, Dropdown, Image, Form, TextArea, Input } from 'semantic-ui-react';
import $ from "jquery";
import TextField from '@material-ui/core/TextField';

import Server from '../../../functions/server';
import Adds from '../../media/add.png';
import Loading from '../../loadings';

class Title extends React.Component {

  state = {
    addDialog: false, maxWidth: 'sm', fullWidth: true,
    file: Adds, comboOption: [], combo: 0
  }

  componentDidMount() {
    this.getCustomerType();
    this.getCombo();
  }

  getCombo() {
    let context = this;
    context.setState({ load: true, message: 'Getting Offers Details' });
    $.ajax({
      type: 'POST',
      url: Server() + 'combo/getallcombo.php',
      success: function(data) {
        context.setState({ load: false });
        try {
          data = JSON.parse(data);
          context.setCombo(data);
        } catch (e) {
          context.setState({ load: false });
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  getCustomerType() {
    let context = this;
    context.setState({ load: true, message: 'Getting Executive!!!' });
    let data1 = {};
    $.ajax({
      type: 'POST', data: data1,
      url: Server() + 'menucontrol/getcustomertypes.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          context.setCustomerTypes(data);
        } catch (e) {
          context.setState({ load: false });
        }
      },
      error: function(err) {
        context.setState({ load: false });
        alert('Try again!!!')
      }
    });
  }

  setCustomerTypes(data) {
    let context = this;
    var x = [];
    data.map((y) => { x.push({key: y.type_name, text: y.type_name, value: y.id}); });
    try {
      context.setState({ customerTypeOption: x, load: false });
    } catch (e) {}
  }

  setCombo(data) {
    let context = this;
    var x = [];
    data.map((y) => {
      x.push({key: y.id+"->"+y.combo_name, text: y.id+"->"+y.combo_name, value: y.id});
    });
    try {
      context.setState({ comboOption: x });
    } catch (e) {}
  }

  handleClose = () => { this.setState({ addDialog: false }); };

  onChange = (type) => (f, { value }) => { this.setState({ [type]: value }) }

  handleChange = name => event => { this.setState({ [name]: event.target.value }); };

  save() {
    let context = this;
    let title = this.state.title;
    let startDate = this.state.start;
    let endDate = this.state.end;
    let customertype = this.state.type;
    let description = this.state.description;
    let image = this.state.image;
    if (!title) { this.setState({ error: "Enter the Title!!!" }); return; }
    if (!startDate) { this.setState({ error: "Enter the startDate!!!" }); return; }
    if (!endDate) { this.setState({ error: "Enter the endDate!!!" }); return; }
    if (!customertype) { this.setState({ error: "Enter the customertype!!!" }); return; }
    if (!description) { this.setState({ error: "Enter the description!!!" }); return; }
    if (!image) { this.setState({ error: "Choose the Offer Image!!!" }); return; }
    customertype = JSON.stringify(customertype);
    var formData = new FormData();
    formData.append('title', title);
    formData.append('offer', description);
    formData.append('start_date', startDate);
    formData.append('end_date', endDate);
    formData.append('customer_type', customertype);
    formData.append('file', this.state.image);
    formData.append('combo', this.state.combo);
    $.ajax({
      type: 'POST', processData: false, contentType: false,
      data: formData, url: Server() + 'offer/insert.php',
      success: function(data) {
        if (data == 1) {
          context.setState({ addDialog: false, load: false })
          context.props.getOffers();
        }
        else {
          context.setState({ load: false })
        }
      },
      error: function(err) {
        context.setState({ load: false });
        alert('Try again!!!')
      }
    });
  }

  handleFile = e => {
    this.updateLocalfile(e.target.files[0]);
    this.setState({ image: e.target.files[0] })
  }

  updateLocalfile(value) {
    let reader  = new FileReader();
    let context = this;
    reader.addEventListener("load", function () {
      let out = reader.result;
      context.setState({ file: out });
    }, false);
    if (value) {
      reader.readAsDataURL(value);
    }
  }

  render() {
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <Button fluid primary onClick={ () => { this.setState({ addDialog: true }) } } style={{display: this.props.offeredit}}>Add Offer</Button>
        <React.Fragment>
          <Dialog fullWidth={this.state.fullWidth}
            maxWidth={this.state.maxWidth}  open={this.state.addDialog}
            onClose={this.handleClose} aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">Add Offer</DialogTitle>
            <DialogContent>
              <DialogContentText>
                <Grid>
                  <Grid.Column mobile={16} tablet={16} computer={16}>
                    <b>Title</b><br/>
                    <Input  value={this.state.title} onChange={this.onChange('title')} fluid />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={16}>
                    <Form>
                      <TextArea placeholder='Offer Description' onChange={this.onChange('description')}/>
                    </Form>
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={8}>
                    Start Date<br/>
                    <input type="date" id="start_date" style={{width: '100%', height: 35 }}
                      onChange={this.handleChange('start')} />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={8}>
                    End Date<br/>
                    <input type="date" id="end_date" style={{width: '100%', height: 35 }}
                      onChange={this.handleChange('end')} />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={8}>
                    Customer Type<br/>
                    <Dropdown multiple id="Type" onChange={this.onChange('type')}
                      search selection options={this.state.customerTypeOption}
                      value={this.state.type} fluid style={{ borderColor: '#5A9CBB' }} />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={8}>
                    Select Combo<br/>
                    <Dropdown id="Type" onChange={this.onChange('combo')}
                      search selection options={this.state.comboOption}
                      value={this.state.combo} fluid style={{ borderColor: '#5A9CBB' }} />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={16}>
                    <b>Offer Image</b><br/>
                    <input id='imagess' type="file" onChange={this.handleFile} style={{display: 'none'}}/>
                    <label htmlFor='imagess'>
                      <Image src={this.state.file} size='small' id='imagess'
                      style={{width: '100%', height: 300, cursor: 'pointer'}} />
                    </label>
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={16}>
                    <div style={{color: 'red'}}><center>{this.state.error}</center></div>
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={8}>
                    <Button fluid onClick={this.handleClose}>Cancel</Button>
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={8}>
                    <Button fluid onClick={this.save.bind(this)}>Add Offer</Button>
                  </Grid.Column>
                </Grid>
              </DialogContentText>
            </DialogContent>
          </Dialog>
        </React.Fragment>
      </div>
    );
  }
}

export default Title;
